import { makeStyles } from "tss-react/mui"
import { alpha } from "@mui/material/styles"
import { Box, Typography } from "@mui/material"

import type { TakeawayKitchen } from "../takeawayTypes"

const useStyles = makeStyles()((theme) => ({
    heroWrap: {
        position: "relative",
        flexShrink: 0,
    },
    heroImage: {
        width: "100%",
        height: "25rem",
        objectFit: "cover",
        display: "block",
    },
    heroPlaceholder: {
        width: "100%",
        height: "25rem",
        backgroundColor: theme.palette.tailwind.slate[300],
    },
    heroOverlay: {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        padding: "1.5rem",
        background: `linear-gradient(0deg, ${alpha(theme.palette.common.black, 0.4)} 0%, transparent 70.25%)`,
    },
    heroOverlayPlaceholder: {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        padding: "1.5rem",
    },
    heroTitle: {
        color: theme.palette.common.white,
        fontWeight: 700,
    },
}))

type TakeawayHeroProps = Readonly<{
    kitchen: TakeawayKitchen
    imageUrl: string | undefined
}>

export function TakeawayHero({ kitchen, imageUrl }: TakeawayHeroProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.heroWrap}>
            {imageUrl ? (
                <>
                    <img src={imageUrl} className={classes.heroImage} alt={kitchen.name} />
                    <Box className={classes.heroOverlay}>
                        <Typography variant="h3" className={classes.heroTitle}>{kitchen.name}</Typography>
                    </Box>
                </>
            ) : (
                <>
                    <Box className={classes.heroPlaceholder} />
                    <Box className={classes.heroOverlayPlaceholder}>
                        <Typography variant="h3" className={classes.heroTitle}>{kitchen.name}</Typography>
                    </Box>
                </>
            )}
        </Box>
    )
}
